<template>
  <v-card flat class="mb-7">
    <v-dialog v-model="dialog" max-width="500px">

              <v-card style='padding:20px;'>
                

                <v-card-text>
                    <h2> View / Edit Record</h2>
                    <span style='float:right;margin-top:-20px;margin-right:-20px;'>
                       <v-icon small @click="dialog = false">mdi-close</v-icon>

                    </span>

                </v-card-text>    
                   <v-form v-model="validForm" ref="form" >
 
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='nameRules'
                          v-model="editedItem['firstname']"
                          required
                          label="First Name"
                          placeholder="First name"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='nameRules'
                          v-model="editedItem['surname']"
                          required
                          label="Surname"
                          placeholder="Surname"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='nameRules'
                          v-model="editedItem['email']"
                          required
                          label="E-Mail"
                          placeholder="E-Mail"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='nameRules'
                          v-model="editedItem['postcode']"
                          required
                          label="Post Code"
                          placeholder="Post Code"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='nameRules'
                          v-model="editedItem['state']"
                          required
                          label="State"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='digitRules'
                          v-model="editedItem['age']"
                          required
                          label="Age"
                          placeholder="Age"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                        <v-col cols="12">
                          <v-text-field
                          :rules='digitRules'
                          v-model="editedItem['healthRating']"
                          required
                          label="Health Rating"
                          placeholder="Health Rating"
                          outlined
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  <v-row>  
                    <v-col cols="12">
                          <v-select
                          required
                        :items="lgasAll"
                      :rules='nameRules'
                        item-text="name"
                        v-model='editedItem["lga"]'
                        label="LGA"
                        outlined
                        dense
                      >
                          </v-select>
                    </v-col>
                  </v-row>
                  <v-row>  
                    <v-col cols="12">
                          <v-select
                          required
                        :items='["Male", "Female"]'
                      :rules='nameRules'
                        item-text="name"
                        v-model='editedItem["gender"]'
                        label="Gender"
                        outlined
                        dense
                      >
                          </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
            <v-select required :items="activity" v-model="editedItem.currentActivity" label="Current level of physical activity / structured activity per week?" outlined dense > </v-select>

                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
            <v-select required :items="barrier" v-model="editedItem.currentBarrier" label="What is your main barrier to keeping physically active?" outlined dense > </v-select>

                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
            <v-checkbox required v-model="editedItem.culturalIdentity" :label="`I identify as Aboriginal or Torres Strait Islander`"></v-checkbox>
                    </v-col>
                  </v-row>
      <v-row v-if='added === 1'>
        <v-col cols="12">
            <v-alert type="success"> Record Has Been Updated </v-alert>
        </v-col>
    </v-row>
    <v-row v-if='added === 0'>
        <v-col cols="12">
            <v-alert type="success"> Error in Update, please try again </v-alert>
        </v-col>
    </v-row>
    <v-row>  
      <v-col cols="12">
           <v-btn block color='primary'  @click="saveChanges"> SAVE </v-btn>
      </v-col>
    </v-row>

       </v-form>
                 
              </v-card>
            </v-dialog>

<v-card-text class="pa-5">
      <div class=''>
  <v-btn
          class='float-right '
      tile white
      color="primary"
    >
      <v-icon left>
        mdi-file-export
      </v-icon>
      <download-csv
    :data="filteredRecords">
    Export
</download-csv>
    </v-btn>
      </div>
      <div class="d-md-flex align-start">
        <h3 class="title font-weight-bold">Registered Users</h3>
        
        <v-spacer></v-spacer>
        <div class="ml-auto">
          <div style="width:300px">
            <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        style='margin-right:30px;'
        single-line
        hide-details
        
      ></v-text-field>
          </div>
        </div>
      </div>
    <v-data-table style="margin:20px" :headers="headers" :search='search' :items="filteredRecords" sort-by="Date" :sort-desc='true' class="border">
        <template v-slot:item.Date="{ item }">
          <span>{{ new Date(item.registrationDate).toLocaleString()  }}</span>
        </template>
        <!-- <template v-slot:item.Logged="{ item }">
          <span v-if='item.Logged'> Web </span>
          <span v-else> App </span>
        </template> -->

        <template v-slot:item.actions="{ item }" v-if='!$root.isLga'>
          <v-icon small class="mr-2" @click="editItem(item)">mdi-view-stream-outline</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>

      </v-data-table>
    </v-card-text>
      
  </v-card>
</template>

<script>
import {mapState} from 'vuex';
export default {
  
  props:{
    showFilter: {
      type: Boolean,
      default: true
    },
    lga: {
      type: String,
      default: null
    },
    start: {
      type: String,
      default: null
    },
    end: {
      type: String,
      default: null
    },
    submissions:{
      type: Array
    },
    month: {
      type: String,
      default: null
    },
  },
  name: "TheOnDemandList",
  data: () => ({
      activity: ['Never', 'Occasionally but not regularly', '1-2 times a week', '3-4 times a week', '5-7 times a week'],
      barrier: ['Time', 'Work / Family Commitments', 'Financial', 'Motivation', 'Limited access to programs', 'Weather', 'None','Other'],
      date: new Date().toISOString().substr(0, 10),
      state: ["QLD", "NSW", "ACT", "SA", "NT", "TAS", "VIC", "WA"],
      menu: false,
      name:'',
      added:-1,
      search:'',
      validForm: false,
      modal: false,
      menu2: false,
      dialog: false,
     editedIndex:0,
      editedItem:{},
      nameRules: [
        v => !!v || 'Field is required',
        v => v.length > 3 || 'Must be minimum 3 characters',
      ],
      digitRules: [
        v => v > -1 || 'Digit Must Be Greater Then 0',
      ],
    headers:[
      { text: "Registration Date", sortable:true, value: "Date" },
      { text: "First Name", value: "firstname" },
      { text: "Surname", value: "surname" },
      { text: "Email", value: "email" },
      { text: "Age", value: "age" },
      { text: "LGA", value: "lga" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    ready: false,
    select: { state: "January", abbr: "FL" },
  }),
  components: {},
    watch:{
      added(value)
      {
          if(value === 1){
                this.$refs.form.resetValidation()
                this.$refs.form.reset()
                setTimeout(() => {
                    this.added = -1
                }, 3000);
          }
          if(value === 0){
                setTimeout(() => {
                    this.added = -1
                }, 3000);
          }
          
      }
  },
  methods:{
    async saveChanges(){
      if(this.validForm){
              this.loading = true;
                  let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/ondemand/"+this.editedItem.ID );
                await programs.set(this.editedItem,
                (error) => { 
                  this.added = (error) ? 0 : 1 
                  if(!error) {this.dialog = false; this.loading = false;}
                  else this.loading = false
                  }
                )
            }else{
              console.log('form validation failed')
            }
    },
    deleteItem(item) {
        console.log(item)
      const index = this.submissions.indexOf(item);
      let dec = confirm("Are you sure you want to delete this item?");
        if(dec){
          this.submissions.splice(index, 1);
        let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/ondemand/"+item.ID);
        programs.remove()
        }
        
    },
      editItem( index ) {
        this.action = "Edit"
        this.editedIndex = this.submissions.indexOf(index);
        let item =  this.submissions[this.editedIndex];
        this.editedItem['surname'] = item['surname']; 
        this.editedItem.ID = item.ID; 
        this.editedItem['firstname'] = item['firstname']; 
        this.editedItem['email'] = item['email']; 
        this.editedItem['age'] = item['age']; 
        this.editedItem['country'] = item['country']; 
        this.editedItem['state'] = item['state']; 
        this.editedItem['postcode'] = item['postcode']; 
        this.editedItem['gender'] = item['gender']; 
        this.editedItem['lga'] = item['lga']; 
        this.editedItem['currentActivity'] = item['currentActivity']; 
        this.editedItem['currentBarrier'] = item['currentBarrier']; 
        this.editedItem['culturalIdentity'] = item['culturalIdentity']; 
        this.editedItem['healthRating'] = item['healthRating']; 
        this.editedItem['registrationDate'] = item['registrationDate']; 
        this.dialog = true;
      },
  },
  mounted() {
    setTimeout(() => {
      this.ready = true
    }, 2000 
    )
  },
 
  computed: {
    ...mapState(['lgasAll']),
    filteredRecords(){
      let records = []
      let finalRecords = []
      let start = new Date(this.start)
       let end = new Date(this.end)
      if (this.lga.length) {
        records = this.submissions.filter(v => v.lga == this.lga)
      } else {
       records = this.submissions
      }
      if (this.start && this.end) {
       
      //  let now = new Date(Date.now())
      //  console.log("found start and end date", start, end)
       records.forEach(element => {
        let target = new Date(element.registrationDate) 
        if (target >= start && target <= end) {
          finalRecords.push(element)
        }
       }); 

      } else if(this.start && this.end.length < 1)
      {
      //  console.log("found start date but end date is empty", this.start)
      records.forEach(element => {
        let target = new Date(element.registrationDate) 
        if (target >= start) {
          finalRecords.push(element)
        }
       }); 

      }else if(this.end && this.start.length < 1)
      {
      //  console.log("found End date but Start date is empty", this.end) 
      records.forEach(element => {
        let target = new Date(element.registrationDate) 
        if (target <= end) {
          finalRecords.push(element)
        }
       }); 

      }else{
        finalRecords = records
      }

      return finalRecords
    },
    
  },
};
</script>